import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InformationModalService {
  public readonly showModal = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  service(): string {
    return 'information-modal';
  }

}
